export default "__VITE_ASSET__CoUuZ4ay__"